import './CtaSection.css';

const REVIEW_PILLS = [
  {
    id: 'kate',
    name: 'Kate',
    text: 'left a 5 star review',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=80&h=80&q=80',
    style: { top: '6%', right: '18%' },
    blurred: true,
  },
  {
    id: 'jerome',
    name: 'Jerome',
    text: 'left a 5 star review',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=80&h=80&q=80',
    style: { top: '32%', right: '4%' },
    blurred: false,
  },
  {
    id: 'sarah',
    name: 'Sarah',
    text: 'left a 5 star review',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=80&h=80&q=80',
    style: { top: '58%', right: '22%' },
    blurred: true,
  },
  {
    id: 'mike',
    name: 'Mike',
    text: 'left a 5 star review',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=80&h=80&q=80',
    style: { top: '72%', right: '-2%' },
    blurred: false,
  },
  {
    id: 'lisa',
    name: 'Lisa',
    text: 'left a 5 star...',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=80&h=80&q=80',
    style: { top: '18%', right: '-8%' },
    blurred: true,
  },
] as const;

export function CtaSection() {
  return (
    <section className="cta" aria-labelledby="cta-heading">
      <div className="container">
        <div className="cta_div_wrapper">
          <div className="cta__content">
            <h2 id="cta-heading" className="cta__heading">
              Ready to boost your business?
            </h2>
            <p className="cta__text cta__text--desktop">
              Start seeing reviews within the first week and never miss a new
              review again
            </p>
            <p className="cta__text cta__text--mobile">
              Start seeing reviews within the first week of activation and
              never miss a new review again
            </p>
            <a href="#pricing" className="cta__button">
              Start Getting Reviews
            </a>
          </div>

          <div className="cta__visual" aria-hidden="true">
            {REVIEW_PILLS.map((pill) => (
              <div
                key={pill.id}
                className={`cta-review-pill ${
                  pill.blurred ? 'cta-review-pill--blur' : ''
                }`}
                style={pill.style}
              >
                <img
                  className="cta-review-pill__avatar"
                  src={pill.avatar}
                  alt=""
                />
                <span className="cta-review-pill__text">
                  <strong>{pill.name}</strong> {pill.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
